import { FC, Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import LocationMarker from "components/AnyReactComponent/LocationMarker";
import GoogleMapReact from "google-map-react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import NcImage from "shared/NcImage/NcImage";
import ModalPhotos from "./ModalPhotos";
import MobileFooterSticky from "./MobileFooterSticky";
import { useParams } from "react-router-dom";
import { DataDetailType } from "data/types";
// import Stars from "components/Stars/Stars";
import EurosSigns from "components/EurosSigns/EurosSigns";
import { getRestaurantData } from "services/api";
import { setDo } from "../../store/actions/do";
import { setStayCurrentTimeslots } from "../../store/actions/stayCurrentTimeslots";
import { useDispatch, useSelector } from "react-redux";
import { StateNames } from "services/stateNameService";
// import { addToCart, removeFromCart } from "store/actions/cart";
import { euro } from "utils/currency";
import { getLongDescText } from "../../helpers/methods";
import PlaceGuestsInput from "components/HeroSearchForm/PlaceGuestsInput";
import PlaceTimeSlotsInput from "components/HeroSearchForm/PlaceTimeSlotsInput";
import PlaceInOutdoorInput from "components/HeroSearchForm/PlaceInOutdoorInput";
import PlaceDateSingleInput from "components/HeroSearchForm/PlaceDateSingleInput";
import TripadvisorStars from "components/Stars/TripadvisorStars";
import { addWhereToEat, removeWhereToEat } from "store/actions/cart";
import moment from "moment";
import "react-placeholder/lib/reactPlaceholder.css";
import {
  fetchHowToMoveAround,
  fetchWhatsExtra,
  fetchWhatToDo,
  fetchWhereToEat,
} from "store/actions/data";
import ReactPlaceholder from "react-placeholder";
import {
  TextBlock,
  RectShape,
  RoundShape,
} from "react-placeholder/lib/placeholders";
// import { get } from "lodash";
import { GOOGLE_MAPS_KEY } from "config/environment";
import CancelationPolicySection from "components/CancelationPolicy/TermsAndConditionsSection";
import TermsAndConditionsSection from "components/CancelationPolicy/TermsAndConditionsSection";
import { PlaceGuestsObject } from "components/HeroSearchForm2Mobile/PlaceGuestsInput";
import isPricePerPerson from "utils/isPricePerPerson";
import MinusIcon from "svg/MinusIcon";
import PlusIcon from "svg/PlusIcon";
import AddToCartModal from "components/AddToCartModal/AddToCartModal";

export interface RestaurantDetailPageProps {
  className?: string;
  isPreviewMode?: boolean;
  data?: DataDetailType[];
}

const RestaurantDetailPage: FC<RestaurantDetailPageProps> = ({
  className = "",
  isPreviewMode,
  data = [],
}) => {
  let params = useParams();
  const dispatch = useDispatch();

  const stayCurrentTimeslots = useSelector(
    (state: any) => state.stayCurrentTimeslots.stayCurrentTimeslots
  );
  const darkModeState = (state: any) => state.darkMode;
  const isDarkMode = useSelector(darkModeState).isDarkMode;
  const TravelDates = useSelector((state: any) => state.search.dates);
  const travelers = useSelector((state: any) => state.search.guests);
  const startDate = TravelDates.startDate;
  // const endDate = TravelDates.endDate;
  const guestsCount = travelers.guestAdults;
  const guestWheelChairCount = travelers.guestWheelchair;
  const [restaurantGuests, setRestaurantGuests] = useState<PlaceGuestsObject>({
    guestAdults: guestsCount !== null ? guestsCount : 0,
    guestChildren: 0,
    guestInfants: 0,
    guestWheelchair: guestWheelChairCount !== null ? guestWheelChairCount : 0,
  });
  const totalRestaurantGuests =
    (restaurantGuests?.guestAdults || 0) +
    (restaurantGuests?.guestWheelchair || 0);

  const currentPage = window.location.pathname.split("/")[1];

  const [isLoading, setIsLoading] = useState(true);
  const [dayName, setDayName] = useState("sun");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isVisitable, setIsVisitable] = useState(true);
  const [isIndoorOutdoorOptions, setIsIndoorOutdoorOptions] = useState(1);
  const [place, setPlace] = useState<DataDetailType>();
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<string>("");
  const [selectedSeating, setSelectedSeating] = useState<string>("");
  // const [selectedDate, setSelectedDate] = useState<string | undefined>("");

  const currentUserState = (state: any) => state.auth;
  const auth = useSelector(currentUserState);

  let [isOpenModalVirtualRoom, setIsOpenModalVirtualRoom] = useState(false);

  const [selectedDate, setSelectedDate] = useState<moment.Moment | null>(null);

  useEffect(() => {
    if (startDate) {
      setSelectedDate(moment(startDate));
    }
  }, [startDate]);

  const [showAddToCartModal, setShowAddToCartModal] = useState(false);
  const [filteredAvailableTimeSlots, setFilteredAvailableTimeSlots] = useState<
    string[]
  >([]);

  // const selectedIds: number[] = useSelector((state: any) =>
  //   state.cart.whereToEat.map((item: any) => item.id)
  // );

  const selectedIds: any = useSelector((state: any) =>
    (state.cart.whereToEat ?? []).map((item: any) => item._id)
  );

  const details = async () => {
    const data = await getRestaurantData(params.id);

    if (data.place) {
      setPlace(data.place);
      dispatch(setDo(data.place));
      setSelectedDate(startDate);
      getDayName(startDate);
      dispatch(
        setStayCurrentTimeslots(
          data.place.perDayData[getDayName(startDate)].availableTimeSlots
        )
      );
      setIsVisitable(data.place.perDayData[getDayName(startDate)].visitable);
      setIsIndoorOutdoorOptions(data.place.indoorOutdoorOptions);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
    return data;
  };

  const [isOpen, setIsOpen] = useState(false);
  const [openFocusIndex, setOpenFocusIndex] = useState(0);
  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);

  const useSmoothScroll = () => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        const scrollPercentage =
          (window.pageYOffset / window.innerHeight) * 100;
        setIsScrolled(scrollPercentage > 65);

        // Scroll to a specific element or position
        const targetElement = document.getElementById("targetElementId");
        targetElement?.scrollIntoView({
          behavior: "smooth",
        });
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    return isScrolled;
  };

  const isScrolled = useSmoothScroll();

  const getDayName = (date: any): string => {
    const options: Intl.DateTimeFormatOptions = { weekday: "short" };
    const dayName = date.toLocaleString("en-US", options).split(",")[0];
    const dayNameLowerCase = dayName.slice(0, 3).toLowerCase();
    setDayName(dayNameLowerCase);
    if (perDayData && perDayData[dayNameLowerCase]) {
      let slots = perDayData[dayNameLowerCase].availableTimeSlots;
      dispatch(setStayCurrentTimeslots(slots));
    }
    return dayNameLowerCase;
  };

  // const updateDayData = async (date: any) => {
  //   setSelectedDate(moment(date).add(0, "days"));
  //   setDayName(getDayName(date));
  //   dispatch(
  //     setStayCurrentTimeslots(perDayData[getDayName(date)].availableTimeSlots)
  //   );
  //   setIsVisitable(perDayData[getDayName(date)].visitable);
  // };

  const handleDateChange = (newDate: moment.Moment | null) => {
    if (newDate) {
      setSelectedDate(newDate);
    }
  };

  useEffect(() => {
    details();
  }, [dispatch]);

  const {
    id,
    _id,
    type,
    stars,
    name,
    fullAddress,
    pricePer,
    href,
    lhref,
    overview,
    accessibilityFeatures,
    accessibilityIcons,
    detailsImgs,
    map,
    notes,
    price,
    cuisines,
    dietaries,
    availableTimeSlotsPerDay,
    // max_occupancy,
    cancelationPolicy,
    thingsToKnow,
    perDayData,
    notAvailableDates,
    whatIsIncludes,
    whatNotIncludes,
    bank_holidays,
    // indoorOutdoorOptions,
    rating,
  } = place || {};

  useEffect(() => {
    if (availableTimeSlotsPerDay && selectedDate) {
      const selectedDayOfWeek = moment(selectedDate, "MM/DD/YYYY").format(
        "dddd"
      ); // e.g., 'Monday'
      const daySlotsObj = availableTimeSlotsPerDay.find(
        (slot: { day: string }) => slot.day === selectedDayOfWeek
      );
      if (daySlotsObj) {
        setFilteredAvailableTimeSlots(daySlotsObj.timeSlots);
      } else {
        setFilteredAvailableTimeSlots([]);
      }
    } else {
      setFilteredAvailableTimeSlots([]);
    }
  }, [availableTimeSlotsPerDay, selectedDate]);

  useEffect(() => {
    switch (StateNames[currentPage as keyof typeof StateNames]) {
      case StateNames["what-to-do-detail"]:
        dispatch(fetchWhatToDo());
        break;
      case StateNames["where-to-eat-and-drink-detail"]:
        dispatch(fetchWhereToEat());
        break;
      case StateNames["how-to-move-around-detail"]:
        dispatch(fetchHowToMoveAround());
        break;
      case StateNames["what-is-extra-detail"]:
        dispatch(fetchWhatsExtra());
        break;
    }
  }, []);

  // const isOnCart = selectedIds.includes(id);

  // const addToCartHandler = () => {
  //   if (isOnCart) {
  //     dispatch(
  //       removeFromCart({
  //         item: place!,
  //         storeKey: StateNames[currentPage as keyof typeof StateNames],
  //       })
  //     );
  //   } else {
  //     dispatch(
  //       addToCart({
  //         item: place!,
  //         storeKey: StateNames[currentPage as keyof typeof StateNames],
  //       })
  //     );
  //   }
  // };
  const isOnCart = selectedIds.includes(_id);
  const addToCartHandler = () => {
    if (place) {
      if (isOnCart) {
        dispatch(removeWhereToEat(place._id!));
      } else {
        dispatch(
          addWhereToEat({
            _id: place._id!,
            cart_type: "WHERE_TO_EAT",
            inputs: {
              date: selectedDate?.format("l") || "",
              seating: selectedSeating,
              timeslot: selectedTimeSlot,
              guests: totalRestaurantGuests,
            },
            value: { ...place, price: totalPrice(false) },
          })
        );
        if (localStorage.getItem("disableNotification") !== "true") {
          setShowAddToCartModal(true);
        }
      }
    }
  };

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const handleOpenModal = (index: number) => {
    setIsOpen(true);
    setOpenFocusIndex(index);
  };

  function closeModalVirtualRoom() {
    setIsOpenModalVirtualRoom(false);
  }

  function openModalVirtualRoom() {
    setIsOpenModalVirtualRoom(true);
  }

  const handleCloseModal = () => setIsOpen(false);

  // placeholders...
  // let placeholderColor = isDarkMode ? "#CCCCCC" : "#E0E0E0";
  let placeholderColor = isDarkMode ? "#FFFFCC" : "#E0E0E0";
  const pricePlaceholder = (
    <div className="price-placeholder">
      <TextBlock color={placeholderColor} rows={2} />
    </div>
  );

  const btnPlaceholder = (
    <div className="Btn-placeholder">
      <RoundShape style={{ width: 380, height: 50 }} color={placeholderColor} />
    </div>
  );

  const sideboxesPlaceholder = (
    <div className="sidebars-placeholder">
      <RoundShape
        style={{ width: 378, height: 178 }}
        color={placeholderColor}
      />
    </div>
  );

  const textFourRowsPlaceholder = (
    <div className="text-4-placeholder">
      <TextBlock color={placeholderColor} rows={4} />
    </div>
  );

  const galleryPlaceholder = (
    <div className="gallery-placeholder">
      <RectShape
        style={{ width: 1000, height: 590 }}
        color={placeholderColor}
      />
    </div>
  );

  const subGalleryPlaceholder = (
    <div className="subGallery-placeholder">
      <RectShape style={{ width: 500, height: 290 }} color={placeholderColor} />
    </div>
  );

  const mapPlaceholder = (
    <div className="map-placeholder">
      <RectShape style={{ width: 725, height: 400 }} color={placeholderColor} />
    </div>
  );

  const showAllPhotosPlaceholder = (
    <div className="showAllPhotos-placeholder">
      <RectShape style={{ width: 50, height: 20 }} color={placeholderColor} />
    </div>
  );

  const textOneRowPlaceholder = (
    <div className="price-placeholder">
      <TextBlock color={placeholderColor} rows={1} />
    </div>
  );

  const textTwoRowsPlaceholder = (
    <div className="text-2-placeholder">
      <TextBlock color={placeholderColor} rows={2} />
    </div>
  );

  const textFiveRowsPlaceholder = (
    <div className="text-5-placeholder">
      <TextBlock color={placeholderColor} rows={5} />
    </div>
  );

  const textTenRowsPlaceholder = (
    <div className="text-10-placeholder">
      <TextBlock color={placeholderColor} rows={10} />
    </div>
  );

  const ratePlaceholder = (
    <div className="rate-placeholder">
      <RectShape style={{ width: 150, height: 30 }} color={placeholderColor} />
    </div>
  );

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={textOneRowPlaceholder}
            showLoadingAnimation
          >
            <div className="flex flex-row">
              <span className="mr-1">{type} </span>
            </div>
          </ReactPlaceholder>
          <div className="flex items-center justify-end">
            <ReactPlaceholder
              ready={!isLoading}
              customPlaceholder={ratePlaceholder}
              showLoadingAnimation
            >
              <div>
                <div className="flex items-center justify-end">
                  <div className="bg-[#35e0a1] rounded-full h-8 w-8 flex items-center justify-center mr-4">
                    <i className="lab la-tripadvisor text-black text-2xl"></i>
                  </div>
                  <div>
                    {rating ? (
                      <TripadvisorStars stars={rating} key={`place-stars`} />
                    ) : null}
                  </div>
                </div>
              </div>{" "}
            </ReactPlaceholder>
          </div>
        </div>

        {/* 2 */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={textTwoRowsPlaceholder}
          showLoadingAnimation
        >
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
            {name}
          </h2>
        </ReactPlaceholder>
        {/* 3 */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={textOneRowPlaceholder}
          showLoadingAnimation
        >
          <div className="flex items-center space-x-4">
            <span>
              <i className="las la-map-marker-alt"></i>
              <span className="ml-1"> {fullAddress} </span>
            </span>
          </div>
        </ReactPlaceholder>

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        {/* Duration, max people & languages for the place */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={textTwoRowsPlaceholder}
          showLoadingAnimation
        >
          <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
            <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 text-center sm:text-left sm:space-x-3 ">
              <ReactPlaceholder
                ready={!isLoading}
                customPlaceholder={textOneRowPlaceholder}
                showLoadingAnimation
              >
                {!!stars && <EurosSigns EurosSigns={stars} />}
              </ReactPlaceholder>
            </div>
            <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 text-center sm:text-left sm:space-x-3 ">
              <i className="las la-utensils text-2xl"></i>
              <span className="">{getLongDescText(cuisines ?? [])}</span>
            </div>
            <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 text-center sm:text-left sm:space-x-3 ">
              <i className="las la-tag text-2xl"></i>
              <span className="">{getLongDescText(dietaries ?? [])}</span>
            </div>
          </div>
        </ReactPlaceholder>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Overview</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={textTenRowsPlaceholder}
          showLoadingAnimation
        >
          <div className="text-neutral-6000 dark:text-neutral-300 prose">
            <div dangerouslySetInnerHTML={{ __html: overview }} />
          </div>
        </ReactPlaceholder>
      </div>
    );
  };

  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Accessibility Features </h2>
          <br />
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={textTenRowsPlaceholder}
            showLoadingAnimation
          >
            <div className="text-neutral-6000 dark:text-neutral-300 prose">
              <div
                dangerouslySetInnerHTML={{ __html: accessibilityFeatures }}
              />
            </div>
          </ReactPlaceholder>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={textFiveRowsPlaceholder}
          showLoadingAnimation
        >
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
            {accessibilityIcons &&
              accessibilityIcons
                ?.filter((_, i) => i < 12)
                .map((item) => (
                  <div key={item.name} className="flex items-center space-x-3">
                    <i className={`text-3xl las ${item.icon}`}></i>
                    <span className=" ">{item.name}</span>
                  </div>
                ))}
          </div>
        </ReactPlaceholder>

        {/* ----- */}
        {accessibilityIcons && accessibilityIcons?.length >= 13 && (
          <>
            <div className="w-14 border-b border-neutral-200"></div>
            <div>
              <ButtonSecondary onClick={openModalAmenities}>
                View more
              </ButtonSecondary>
            </div>
            {renderMotalAmenities()}
          </>
        )}
      </div>
    );
  };

  const renderMotalAmenities = () => {
    return (
      <Transition appear show={isOpenModalAmenities} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalAmenities}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      Accessibility Features
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalAmenities} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                    {accessibilityIcons
                      ?.filter((_, i) => i < 1212)
                      .map((item) => (
                        <div
                          key={item.name}
                          className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
                        >
                          <i
                            className={`text-4xl text-neutral-6000 las ${item.icon}`}
                          ></i>
                          <span>{item.name}</span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderSection7 = () => {
    if (typeof map === "undefined") {
      return false;
    }

    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Location</h2>
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={textOneRowPlaceholder}
            showLoadingAnimation
          >
            <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
              {fullAddress}
            </span>
          </ReactPlaceholder>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3">
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={mapPlaceholder}
            showLoadingAnimation
          >
            <div className="rounded-xl overflow-hidden">
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: GOOGLE_MAPS_KEY,
                }}
                yesIWantToUseGoogleMapApiInternals
                defaultZoom={15}
                defaultCenter={{
                  lat: map.lat,
                  lng: map.lng,
                }}
              >
                <LocationMarker lat={map.lat} lng={map.lng} />
              </GoogleMapReact>
            </div>
          </ReactPlaceholder>
        </div>
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <TermsAndConditionsSection
        cancelationPolicy={cancelationPolicy}
        dayName={dayName}
        isLoading={isLoading}
        notes={notes}
        perDayData={perDayData}
        thingsToKnow={thingsToKnow}
      />
    );
  };

  const renderMotalVirtualRoom = () => {
    return (
      <Transition appear show={isOpenModalVirtualRoom} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalAmenities}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-4 h-screen w-full">
                <div className="inline-flex  flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-6 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      {" "}
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalVirtualRoom} />
                    </span>
                  </div>
                  <div className="h-full overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                    <iframe
                      data-hj-allow-iframe
                      title="VR_Rom"
                      src={auth.isAuthenticated ? lhref : href}
                      className={"w-full h-full"}
                    />
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderSideBoxes = () => {
    if (place && perDayData?.[dayName]?.visitable) {
      return (
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <div className="flex flex-row divide-x divide-neutral-200 dark:divide-neutral-700 !grid-cols-1 sm:!grid-cols-2">
            {perDayData[dayName].availableTimeSlots !== undefined && (
              <PlaceGuestsInput
                fieldClassName="p-4 w-1/2"
                setGuests={setRestaurantGuests}
                guests={restaurantGuests}
                hasButtonSubmit={false}
              />
            )}
            {filteredAvailableTimeSlots?.length > 0 && (
              <PlaceTimeSlotsInput
                anchorDirection={"right"}
                fieldClassName="p-4 grow"
                className="h-full grow"
                setSelectedTimeSlot={setSelectedTimeSlot}
                data={filteredAvailableTimeSlots}
              />
            )}
          </div>
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          {![1, 2, 3].includes(isIndoorOutdoorOptions) ? (
            <PlaceDateSingleInput
              defaultValue={moment(selectedDate).add(0, "days")}
              anchorDirection={"left"}
              fieldClassName="p-4 grow"
              className="h-full grow"
              bankHolidays={bank_holidays}
              onChange={(newDate) => handleDateChange(newDate)}
              notAvailableDates={notAvailableDates}
            />
          ) : (
            <div className="flex flex-row divide-x divide-neutral-200 dark:divide-neutral-700 !grid-cols-1 sm:!grid-cols-2">
              <PlaceDateSingleInput
                defaultValue={moment(selectedDate).add(0, "days")}
                anchorDirection={"left"}
                fieldClassName="p-4 grow"
                className="h-full grow flex-1"
                onChange={(newDate) => handleDateChange(newDate)}
                notAvailableDates={notAvailableDates}
                bankHolidays={bank_holidays}
              />
              <PlaceInOutdoorInput
                anchorDirection={"right"}
                fieldClassName="p-4 grow"
                className="h-full grow"
                setSelectedSeating={setSelectedSeating}
                data={stayCurrentTimeslots}
              />
            </div>
          )}
        </form>
      );
    }
    return null;
  };

  const totalPrice = (isOnlyForOne: boolean) => {
    let priceValue = place?.price || 0;
    if (!isOnlyForOne && place?.isPricePerPerson) {
      priceValue = priceValue * totalRestaurantGuests;
    }
    return priceValue;
  };

  const totalPriceToString = (isOnlyForOne: boolean) => {
    return totalPrice(isOnlyForOne).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const renderSidebar = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        {perDayData && perDayData[dayName] && perDayData[dayName].visitable ? (
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={pricePlaceholder}
            showLoadingAnimation
          >
            {perDayData &&
              perDayData[dayName] &&
              perDayData[dayName].pricePerPerson && (
                <div className="flex justify-between">
                  {/* <span className="text-3xl font-semibold">
                    {euro.format(perDayData[dayName].pricePerPerson)}
                    <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
                      {pricePer}
                    </span>
                  </span> */}
                </div>
              )}
          </ReactPlaceholder>
        ) : (
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={pricePlaceholder}
            showLoadingAnimation
          >
            <span className="text-3xl font-semibold">No Availability</span>
          </ReactPlaceholder>
        )}

        {/* ROOM Virtual Tour */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={sideboxesPlaceholder}
          showLoadingAnimation
        >
          {href && (
            <ButtonPrimary
              className="text-2xl virtual-tour"
              onClick={() => openModalVirtualRoom()}
            >
              <i className={`las la-photo-video text-4xl pr-2`}></i>
              Virtual Tour
            </ButtonPrimary>
          )}
          {renderMotalVirtualRoom()}
        </ReactPlaceholder>

        {/* SIDE BOXES */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={sideboxesPlaceholder}
          showLoadingAnimation
        >
          {renderSideBoxes()}
        </ReactPlaceholder>

        {/* SUM */}
        {perDayData && perDayData[dayName] && perDayData[dayName].visitable && (
          <ReactPlaceholder
            ready={!isLoading}
            customPlaceholder={textFourRowsPlaceholder}
            showLoadingAnimation
          >
            <div className="flex flex-col space-y-4">
              <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                <span>
                  {" "}
                  €{totalPriceToString(true)} x {totalRestaurantGuests}{" "}
                  reservation
                </span>
                <span>€{totalPriceToString(false)}</span>
              </div>
              <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                <span>Taxes and other charges</span>
                <span>€0.00</span>
              </div>
              <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
              <div className="flex justify-between font-semibold text-[18px]">
                <span>Total</span>
                <span>€{totalPriceToString(false)}</span>
              </div>
            </div>
          </ReactPlaceholder>
        )}

        {/* SUBMIT */}
        <ReactPlaceholder
          ready={!isLoading}
          customPlaceholder={btnPlaceholder}
          showLoadingAnimation
        >
          {price && (
            <ButtonPrimary
              onClick={() => addToCartHandler()}
              disabled={!perDayData[dayName].visitable}
              className={`
              h-[83px]
              ring-0
              
            ${isOnCart ? "custom-green-button-cart" : ""}`}
            >
              <p className="flex space-x-2 justify-center items-center">
                {isOnCart ? (
                  <>
                    <span> Added To cart</span>
                  </>
                ) : (
                  <>
                    <span>Add to cart</span>
                  </>
                )}
              </p>
            </ButtonPrimary>
          )}
        </ReactPlaceholder>
      </div>
    );
  };

  const renderIncludes = () => {
    return (
      <div className="listingSection__wrap spacer-y-4">
        <div>
          <h2 className="text-2xl font-semibold">Included </h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
          {whatIsIncludes
            ?.filter((_item: any, i: number) => i < 12)
            .map((item: any, index: number) => (
              <div
                key={`includes-${index}`}
                className="flex items-center space-x-3"
              >
                <i className="las la-check-circle text-2xl"></i>
                <span>{item.text}</span>
              </div>
            ))}
        </div>
      </div>
    );
  };

  const renderNonIncludes = () => {
    return (
      <div className="listingSection__wrap spacer-y-4">
        <div>
          <h2 className="text-2xl font-semibold">Not Included </h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
          {whatNotIncludes
            ?.filter((_item: any, i: number) => i < 12)
            .map((item: any, index: number) => (
              <div
                key={`includes-${index}`}
                className="flex items-center space-x-3"
              >
                <i className="las la-minus-circle text-2xl"></i>
                <span>{item.text}</span>
              </div>
            ))}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`ListingRestaurantDetailPage nc-ListingRestaurantDetailPage ${className}`}
      data-nc-id="ListingRestaurantDetailPage"
    >
      {/* SINGLE HEADER */}
      <AddToCartModal
        title={place ? place.name : "Restaurant"}
        showModal={showAddToCartModal}
        onClose={() => setShowAddToCartModal(false)}
      />
      <>
        <header className="container 2xl:px-14 rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
            <div
              className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => handleOpenModal(0)}
            >
              <ReactPlaceholder
                ready={!isLoading}
                customPlaceholder={galleryPlaceholder}
                showLoadingAnimation
              >
                <NcImage
                  containerClassName="absolute inset-0"
                  className="object-cover w-full h-full rounded-md sm:rounded-xl"
                  src={
                    detailsImgs && detailsImgs.length > 0
                      ? detailsImgs[0].url
                      : ""
                  }
                />
              </ReactPlaceholder>
            </div>
            {detailsImgs
              ?.filter((_item: any, i: number) => i >= 1 && i < 5)
              .map((item: any, index: number) => (
                <div
                  key={index}
                  className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                    index >= 3 ? "hidden sm:block" : ""
                  }`}
                >
                  <ReactPlaceholder
                    ready={!isLoading}
                    customPlaceholder={subGalleryPlaceholder}
                    showLoadingAnimation
                  >
                    <NcImage
                      containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                      className="object-cover w-full h-full rounded-md sm:rounded-xl "
                      src={item.url || ""}
                    />
                  </ReactPlaceholder>

                  {/* OVERLAY */}
                  <div
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                    onClick={() => handleOpenModal(index + 1)}
                  />
                </div>
              ))}

            <div
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
              onClick={() => handleOpenModal(0)}
            >
              <ReactPlaceholder
                ready={!isLoading}
                customPlaceholder={showAllPhotosPlaceholder}
                showLoadingAnimation
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                  />
                </svg>
                <span className="ml-2 text-neutral-800 text-sm font-medium">
                  Show all photos
                </span>
              </ReactPlaceholder>
            </div>
          </div>
        </header>
        {/* MODAL PHOTOS */}
        <ModalPhotos
          imgs={detailsImgs || []}
          isOpen={isOpen}
          onClose={handleCloseModal}
          initFocus={openFocusIndex}
          uniqueClassName="nc-ListingRestaurantDetailPage-modalPhotos"
        />
      </>

      {/* MAIn */}
      <main className="container relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
          {renderSection3()}
          {renderIncludes()}
          {renderNonIncludes()}
          {/* {renderSection4()} */}
          {/* {renderSectionCheckIndate()} */}
          {/* {renderSection5()} */}
          {/* {renderSection6()} */}
          {renderSection7()}
          {renderSection8()}
          <div className="pt-8"></div>
        </div>

        {/* SIDEBAR */}
        {/* <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div
            className={`sticky ${isScrolled ? "smooth-scroll top-28 pt-20 pb-12" : ""
              }`}
          >
            {place && <div>{renderSidebar()}</div>}
          </div>
        </div> */}
        <div className="md:block md:flex-grow md:mt-0">
          <div className={"sticky smooth-scroll top-48 pb-12 "}>
            <div>{renderSidebar()}</div>
          </div>
        </div>
      </main>

      {/* OTHER SECTION */}
    </div>
  );
};

export default RestaurantDetailPage;
